export const RDF = {
    type: "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
};
export const RDFS = {
    subClassOf: "http://www.w3.org/2000/01/rdf-schema#subClassOf",
    domain: "http://www.w3.org/2000/01/rdf-schema#domain",
    range: "http://www.w3.org/2000/01/rdf-schema#range",
};
export const POJEM = {
    typObjektu: "https://slovník.gov.cz/základní/pojem/typ-objektu",
    typVlastnosti: "https://slovník.gov.cz/základní/pojem/typ-vlastnosti",
    typVztahu: "https://slovník.gov.cz/základní/pojem/typ-vztahu",
};
export const SKOS = {
    prefLabel: "http://www.w3.org/2004/02/skos/core#prefLabel",
    definition: "http://www.w3.org/2004/02/skos/core#definition",
    inScheme: "http://www.w3.org/2004/02/skos/core#inScheme",
};
export const OWL = {
    maxQualifiedCardinality: "http://www.w3.org/2002/07/owl#maxQualifiedCardinality",
    minQualifiedCardinality: "http://www.w3.org/2002/07/owl#minQualifiedCardinality",
};
//# sourceMappingURL=sgov-vocabulary.js.map